import React, { forwardRef, useImperativeHandle, useState } from 'react';
import PropTypes from 'prop-types';
import { handleUploadFile } from '../../services/utilityFunctions';
/**
 * ONLY PREPARED FOR PDF
 * IF IN THE FUTURE WE WANT TO USE FOR EXCEL WE NEED TO UPDATE THE COMPONENT
 * */

const FileUploadBtn = forwardRef((props, ref) => {
  const { _csrf, label, handleFile, fileType, onLoading, isLoading, icon, disabled, customOnClick } = props;
  const [labelText, setLabelText] = useState(label);
  // Create a reference to the hidden file input element
  const hiddenFileInput = React.useRef(null);

  // Programatically click the hidden file input element
  // when the Button component is clicked
  const handleClick = () => {
    hiddenFileInput.current.click();
  };
  // Call a function (passed as a prop from the parent component)
  // to handle the user-selected file
  const handleChange = async event => {
    onLoading(true);
    try {
      const response = await handleUploadFile(_csrf, event);
      setLabelText(response.originalName);
      handleFile(response);
      onLoading(false);
    } catch (e) {
      console.log('*Err', e);
      onLoading(false);
    }
  };

  useImperativeHandle(
    ref,
    () => ({
      handleDownload: () => handleChange(),
    }),
  );

  return (
    <>
      <button
        type="button"
        className={`btn btn-dynamic btn-sm m-btn--pill btn-file ${
          isLoading ?
          ' m-loader m-loader--right m-loader--light' : ''
        }`}
        style={{ fontSize: '1rem' }}
        onClick={customOnClick || handleClick}
        disabled={disabled || isLoading}
      >
        {labelText}
        {icon && <i style={{ marginLeft: '10px' }} className={icon} />}
      </button>
      {!customOnClick && (
        <input
          type="file"
          ref={hiddenFileInput}
          onChange={handleChange}
          style={{ display: 'none' }}
          accept={fileType}
        />
      )}
    </>
  );
});

FileUploadBtn.propTypes = {
  _csrf: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  handleFile: PropTypes.func.isRequired,
  onLoading: PropTypes.func.isRequired,
  customOnClick: PropTypes.func,
  fileType: PropTypes.string,
  isLoading: PropTypes.bool,
  icon: PropTypes.string,
  disabled: PropTypes.bool,
};

FileUploadBtn.defaultProps = {
  customOnClick: null,
  fileType: '.pdf',
  isLoading: false,
  icon: 'fa fa-file-upload',
  disabled: false,
};

export default FileUploadBtn;
